import React, { useState, useEffect } from "react";
import "./header.css";
import CTA from "./CTA";
import HeaderSocial from "./HeaderSocials";

const codeStringES = `const desarrollador = {
  nombre: "Codewords",
  rol: "Fullstack Developer",
  tecnologias: ["React", "Node", "SQL", "C#"],
  aprendeRapido: true,
  solucionaProblemas: true,
  contratable: function() {
    return this.aprendeRapido && this.solucionaProblemas;
  }
};

console.log(desarrollador.contratable()); // true`;

const codeStringEN = `const developer = {
  name: "Codewords",
  role: "Fullstack Developer",
  skills: ["React", "Node", "SQL", "C#"],
  fastLearner: true,
  problemSolver: true,
  hireable: function() {
    return this.fastLearner && this.problemSolver;
  }
};

console.log(developer.hireable()); // true`;

const Header = () => {
  const [text, setText] = useState("");
  const [nameText, setNameText] = useState("");
  const [isEnglish, setIsEnglish] = useState(false);
  const myName = "Codewords";

  useEffect(() => {
    // Animación para la ventana de código
    let i = 0;
    const currentCodeString = isEnglish ? codeStringEN : codeStringES;
    setText(""); // Reiniciar el texto al cambiar de idioma

    const typingInterval = setInterval(() => {
      if (i < currentCodeString.length) {
        setText(currentCodeString.slice(0, i + 1));
        i++;
      } else {
        clearInterval(typingInterval);
      }
    }, 20); // Más rápido para que no tarde tanto al cambiar

    // Animación para el título principal (solo la primera vez)
    let j = 0;
    const nameInterval = setInterval(() => {
      if (j < myName.length) {
        setNameText(myName.slice(0, j + 1));
        j++;
      } else {
        clearInterval(nameInterval);
      }
    }, 150);

    return () => {
      clearInterval(typingInterval);
      clearInterval(nameInterval);
    };
  }, [isEnglish]);

  const toggleLanguage = () => {
    setIsEnglish(!isEnglish);
  };

  return (
    <header>
      <div className="container header__container">
        <div className="header__intro">
          <span className="greeting">HOLA, SOY</span>
          <h1 className="name">
            {nameText}
            <span className="title-cursor">|</span>
          </h1>
          <h5 className="role text-light">Fullstack Developer</h5>
        </div>
        <CTA />
        <HeaderSocial />

        <div className="header__code-window">
          <div className="code-header">
            <div className="code-header-dots">
              <span className="dot red"></span>
              <span className="dot yellow"></span>
              <span className="dot green"></span>
            </div>
            <button className="lang-toggle-btn" onClick={toggleLanguage}>
              {isEnglish ? "ES" : "EN"}
            </button>
          </div>
          <div className="code-content">
            <pre>
              <code>
                {text}
                <span className="cursor">|</span>
              </code>
            </pre>
          </div>
        </div>

        <a href="#contact" className="scroll__down">
          Scroll Down
        </a>
      </div>
    </header>
  );
};

export default Header;
